import isDev from '../constants/isDev';
import acs from '@mos-utils/acs';

import findAppealFound from '../stubs/findAppealFound.json';
import findAppealNotFound from '../stubs/findAppealNotFound.json';
import findAppealError from '../stubs/findAppealError.json';
import favoriteStatus from '../stubs/favoriteStatus.json';
import addToFavoriteData from '../stubs/addToFavorite.json';
import deleteFromFavoriteData from '../stubs/deleteFromFavorite.json';

import { fetchGET, fetchPOST, fetchDELETE } from './fetchHelper';

const baseUrl = '/api/exam-appeal/v1';

const findAppealMockValue =
  isDev && process.env.REACT_APP_FIND_APPEAL
    ? process.env.REACT_APP_FIND_APPEAL
    : null;

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export async function getUserData() {
  return fetchGET(
    `/api/my/v1/blocks?names[]=snils&names[]=children&names[]=registration_data&names[]=person&names[]=passport_rf&names[]=non_residential&names[]=gia`
  );
}

export async function getExamData(params) {
  const { giaNumber, giaCode } = params;
  const formattedCode = giaCode.replace(/[- ]/g, '');

  return fetchGET(`${baseUrl}/get-results/${formattedCode}/${giaNumber}`);
}

export async function getFindAppeal({
  snils,
  exam_type,
  reg_code,
  subject_code,
  exam_date
}) {
  const disableFindAppeal =
    document.cookie.search('disableFindAppeal=true') >= 0;

  if (disableFindAppeal) {
    return findAppealNotFound;
  }

  if (isDev && findAppealMockValue === 'true') {
    await delay(2000);

    if (document.cookie.search('forceFindAppealError=true') >= 0) {
      throw new Error(findAppealError);
    }

    return findAppealFound;
  }

  if (isDev && findAppealMockValue === 'error') {
    await delay(1000);

    return findAppealError;
  }

  if (isDev && findAppealMockValue === 'false') {
    await delay(1000);

    return findAppealNotFound;
  }

  return fetchGET(
    `${baseUrl}/find?snils=${snils}&exam_type=${exam_type}&reg_code=${reg_code}&subject_code=${subject_code}&exam_date=${exam_date}`
  );
}

export async function findRegPlaceNames(params) {
  if (!params?.query) {
    return null;
  }

  const { query, limit = 10 } = params;

  if (isDev) {
    await delay(500);
  }

  return fetchGET(
    `${baseUrl}/find-marriage-registries?query=${query}&limit=${limit}`
  );
}

const favoriteUrl = `${baseUrl}/favorites`;

export async function getFavoriteStatus() {
  if (isDev) {
    await delay(1000);
    return favoriteStatus;
  }

  return fetchGET(favoriteUrl);
}

export async function deleteFromFavorite() {
  if (isDev) {
    await delay(1000);
    return deleteFromFavoriteData;
  }

  return fetchDELETE(favoriteUrl);
}

export async function addToFavorite() {
  if (isDev) {
    await delay(1000);
    return addToFavoriteData;
  }

  return fetchPOST(favoriteUrl);
}
